import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Account} from "../accounts/types.ts";
import {Application} from "../applications/types.ts";


export enum ApplicationAccountStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export type ApplicationAccountFormType = {
                                             accountId?: string
                                             applicationId?: string,
                                         } & { [key: string]: any }


export type ApplicationAccount = {
                                     id: string,
                                     accountId: string,
                                     account: Account,
                                     applicationId: string,
                                     application: Application,
                                     accountApplicationStatus: ApplicationAccountStatus,
                                     createdByUsername?: string,
                                     createdBy?: { givenName: string, familyName: string },
                                     managedByUsername?: string
                                     managedBy?: { givenName: string, familyName: string },
                                     created?: string,
                                     updated?: string,
                                 } & { [key: string]: any }


export interface IApplicationAccountTableColumn extends ITableColumn {
    render?: (item: ApplicationAccount) => ReactNode;
}


export type ListApplicationAccounts = {
    listApplicationAccounts: { items: ApplicationAccount[] }
}

export type GetApplicationAccount = {
    getApplicationAccount: ApplicationAccount
}

export type CreateApplicationAccount = {
    createApplicationAccount: ApplicationAccount
}

export type UpdateApplicationAccount = {
    updateApplicationAccount: ApplicationAccount
}

export type DeleteApplicationAccount = {
    deleteApplicationAccount: string
}

export type ApplicationAccountRecordFormProps = {
    record: ApplicationAccount,
    handleSubmit: (values: ApplicationAccount) => void
    handleCancel: () => void
}
